import { useAuthState } from "react-firebase-hooks/auth";
import { Navigate } from "react-router-dom";
import Spinner from "../components/common/Spinner"; // vanuit src/components/RequireAuth.js
import { auth } from "../firebase"


export default function RequireAuth({ children }) {
    const [user, loading] = useAuthState(auth);

    if (loading) return <Spinner />;
    if (!user) return <Navigate to="/login" />;

    return children;
}